/* src/app/views/sales-channel-external/sales-channel-external.component.css */
.container {
  --surface-soft: #ffffff;
  --surface-strong: #ffffff;
  --border-subtle: #d7e1f2;
  --text-primary: #17233a;
  --action-primary: #046cea;
  --action-primary-hover: #0353b8;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(18, 38, 63, 0.1);
  overflow: hidden;
}
.container-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 32px 42px 8px 42px;
}
.title {
  font-weight: 400;
  font-size: clamp(24px, 4vw, 48px);
  line-height: 1.08;
  color: #17345c;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.sales-channel-body {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 16px 42px 30px 42px;
}
.sales-channel-shell {
  width: min(1020px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(290px, 360px) minmax(460px, 1fr);
  gap: 26px;
  align-items: stretch;
}
.channel-card,
.channel-form-card {
  border-radius: 18px;
  padding: 26px;
  box-sizing: border-box;
}
.channel-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  background: #ffffff;
  border: 1px solid var(--border-subtle);
  box-shadow: 0 12px 28px rgba(24, 49, 86, 0.08);
  position: relative;
  overflow: hidden;
}
.channel-card::before {
  content: none;
  position: absolute;
  inset: auto -40px -60px auto;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}
.channel-visual {
  width: 100%;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7faff;
  backdrop-filter: blur(4px);
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  padding: 22px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}
.image {
  width: min(220px, 60vw);
  height: auto;
  margin: 0;
  filter: drop-shadow(0 10px 16px rgba(8, 24, 56, 0.18));
}
.channel-badge {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--text-primary);
  text-align: center;
  letter-spacing: 0.02em;
  position: relative;
  z-index: 1;
}
.channel-form-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
  background: #ffffff;
  border: 1px solid var(--border-subtle);
  box-shadow: 0 12px 28px rgba(24, 49, 86, 0.08);
}
.chassi-label {
  display: block;
  width: min(500px, 100%);
  font-size: clamp(20px, 3.5vw, 34px);
  line-height: 1.25;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0;
  max-width: 100%;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
  hyphens: none;
}
.chassi-input-row {
  width: min(500px, 100%);
}
.chassi-input {
  width: 100%;
  height: 60px;
  border: 1px solid #b8cae4;
  border-radius: 16px;
  padding: 0 18px;
  font-size: 18px;
  font-weight: 600;
  color: #23304a;
  box-sizing: border-box;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background: #ffffff;
}
.chassi-input:focus {
  border-color: #5d8fd4;
  box-shadow: 0 0 0 4px rgba(93, 143, 212, 0.16);
  outline: none;
}
.margin-top-5,
.chassi-margin-top {
  margin-top: 0;
}
.button-position {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 22px 10px 0 10px;
  border-top: 1px solid #d8e2ee;
  box-sizing: border-box;
}
.action-button {
  width: 172px;
  height: 50px;
  background: var(--action-primary);
  border: 1px solid var(--action-primary);
  border-radius: 14px;
  margin-top: 0;
  margin-right: 0;
  color: #ffffff;
  box-shadow: 0 10px 18px rgba(4, 108, 234, 0.18);
}
.action-button .action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:enabled:hover {
  background: var(--action-primary-hover);
  border-color: var(--action-primary-hover);
}
.action-button:disabled {
  background-color: #e5e5e5;
  border: 1px solid #aaaaaa;
  opacity: 0.75;
  cursor: not-allowed;
  color: #202020;
  box-shadow: none;
}
.action-button:disabled .action-button-label,
.action-button:disabled .pi {
  color: #202020;
}
@media (max-width: 960px) {
  .container-header {
    padding: 20px 22px 10px 22px;
  }
  .title {
    font-size: 34px;
    line-height: 1.15;
  }
  .sales-channel-body {
    padding: 8px 22px 24px 22px;
  }
  .sales-channel-shell {
    grid-template-columns: 1fr;
    width: min(680px, 100%);
  }
  .chassi-label {
    font-size: 28px;
    width: min(500px, 100%);
    max-width: 100%;
  }
}
@media (max-width: 640px) {
  .container-header {
    padding: 16px 14px 8px 14px;
  }
  .title {
    font-size: 24px;
  }
  .sales-channel-body {
    padding: 6px 14px 18px 14px;
    gap: 18px;
  }
  .channel-card,
  .channel-form-card {
    padding: 16px;
  }
  .channel-visual {
    min-height: 200px;
  }
  .image {
    width: min(170px, 58vw);
  }
  .channel-badge {
    font-size: 18px;
  }
  .chassi-label {
    font-size: 24px;
    width: 100%;
  }
  .chassi-input {
    height: 52px;
    padding: 0 14px;
    font-size: 16px;
  }
  .button-position {
    padding: 16px 0 0 0;
  }
  .action-button {
    width: 100%;
    box-shadow: none;
  }
}
/*# sourceMappingURL=sales-channel-external.component-AU4O4TX7.css.map */
